export default "__VITE_ASSET__DAFln5r5__"